import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.timeline' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--timeline' )[0], {
          // type: 'carousel',
          pagination: false,
          arrows: true,
          gap: '32px',
          autoWidth: false,
        } );

        splide.on( 'moved', function( newIndex ) {
          updateNavTitles( newIndex );
        } );

        splide.mount();

        updateNavTitles();
      } );

      function updateNavTitles( index = 0 ) {
        const prevSlide = $( '.timeline .splide__slide' ).eq( index - 1 );
        const nextSlide = $( '.timeline .splide__slide' ).eq( index + 1 );
        console.log( prevSlide );

        const prevYear = $( prevSlide ).find( '.timeline__slide-year' ).text();
        const prevHeading = $( prevSlide ).find( '.timeline__slide-heading' ).text();

        const nextYear = $( nextSlide ).find( '.timeline__slide-year' ).text();
        const nextHeading = $( nextSlide ).find( '.timeline__slide-heading' ).text();

        if ( index > 0 ) {
          $( '.timeline__navigation-info--prev' ).addClass( 'is-active' );
          $( '.timeline__navigation-direction--prev' ).text( 'Previous:' );
          $( '.timeline__navigation-title--prev' ).text( prevYear + ' ' + prevHeading );
        } else {
          $( '.timeline__navigation-info--prev' ).removeClass( 'is-active' );
        }

        if ( index < $( '.timeline .splide__slide' ).length - 1 ) {
          $( '.timeline__navigation-info--next' ).addClass( 'is-active' );
          $( '.timeline__navigation-direction--next' ).text( 'Next:' );
          $( '.timeline__navigation-title--next' ).text( nextYear + ' ' + nextHeading );
        } else {
          $( '.timeline__navigation-info--next' ).removeClass( 'is-active' );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'timeline', COMPONENT );
} )( app );
